import { SxProps, Theme } from '@mui/material'

export interface TopicRefinementButtonStyles {
	enabled: boolean
	sx?: SxProps<Theme>
}

export const styles = ({
	enabled,
	sx,
}: TopicRefinementButtonStyles): SxProps<Theme> => ({
	textTransform: 'uppercase',
	fontFamily: 'Roboto',
	fontSize: '15px',
	fontWeight: 500,
	lineHeight: '26px',
	letterSpacing: '0.46px',
	fontFeatureSettings: "'liga' off, 'clig' off",
	justifyContent: 'flex-start',
	padding: '6px 8px',
	mx: { xs: 'auto', sm: '0' },
	color: enabled ? '#274A62' : 'rgba(0, 0, 0, 0.38)',
	'& .MuiButton-startIcon': {
		color: enabled ? '#274A62' : 'rgba(0, 0, 0, 0.38)',
	},
	'&.Mui-disabled': {
		color: 'rgba(0, 0, 0, 0.38)',
	},
	...sx,
})
